<template>
  <div>
    <div class="card" v-if="selected_validators.length == 0">
      <div class="card-body">
        <p>
          <span>{{ 'no_validators_added' | t }}</span>
        </p>
      </div>
    </div>
    <div class="card mb-2" v-for="(validator, i) in selected_validators">
      <div class="card-body">
        <div class="form-group">
          <button class="btn btn-primary float-right" v-on:click="remove_validator(i)">{{ 'delete' | t }}</button>
        </div>
        <div class="form-group">
          <label>{{ 'validator' | t }}</label>
          <select class="form-control" v-model="validator.validator">
            <option v-for="v in available_validators" :value="v.validator">{{ v.description }}</option>
          </select>
        </div>
        <div class="form-group">
          <label>{{ 'condition' | t }} - {{ 'condition_help_text' | t }}. ({{ 'blank_means_always_run' | t }})</label>
          <input class="form-control" v-model="validator.condition" />
        </div>
        <div class="form-group" v-for="param in find_params(validator)">
          <checkbox
            v-if="param.type == 'boolean'"
            :label="param.title"
            v-model="validator.params[param.title]"
          ></checkbox>
          <template v-else>
            <label>{{ param.title }}</label>
            <input class="form-control" v-model="validator.params[param.title]" />
          </template>
        </div>
      </div>
    </div>
    <br />
    <button class="btn btn-primary" v-on:click="add_validator">{{ 'add_validator' | t }}</button><br /><br />
  </div>
</template>
<script>
export default {
  props: { value: Array },
  data: function () {
    return {
      selected_validators: this.value,
      available_validators: [
        {
          validator: 'Zip::FormatValidator',
          description: 'Validate the format of the zip-code',
          params: {}
        },
        {
          validator: 'Address::AddressLengthValidator',
          description: 'Validate the length of the address-lines is less than',
          params: [{ title: 'length', type: 'number' }]
        },
        {
          validator: 'Address::HouseNumberOnAddressLineValidator',
          description: 'Validate that the first address-line contains a house-number',
          params: {}
        },
        {
          validator: 'Address::LatinLetterValidator',
          description: 'Validate that the address contains latin-letters only',
          params: {}
        },
        {
          validator: 'Address::EmailValidator',
          description: 'Validate that the address & notifications contains valid emails',
          params: {}
        },
        {
          validator: 'Address::CountryWhitelistValidator',
          description: 'Validate delivery address is whitelisted (csv)',
          params: [
            { title: 'countries', type: 'string' },
            { title: 'message', type: 'string' }
          ]
        },
        {
          validator: 'Address::PhoneValidator',
          description: 'Validate phone number is valid',
          params: [
            { title: 'country_specific_validation', type: 'boolean' },
            { title: 'strict_check', type: 'boolean' }
          ]
        }
      ]
    };
  },
  watch: {
    value(newValue) {
      this.selected_validators = newValue;
    }
  },
  methods: {
    find_params(validator) {
      let item = this.available_validators.find((x) => x.validator === validator.validator);
      if (item) {
        return item.params;
      }

      return [];
    },
    add_validator() {
      this.selected_validators.push({
        validator: '',
        condition: '',
        params: {}
      });
    },
    remove_validator(i) {
      this.selected_validators.splice(i, 1);
    }
  }
};
</script>
